import { QuarantineComputersAndVirtualMachinesRestoreForm } from './component/QuarantineComputersAndVirtualMachinesRestoreForm';
import { WEB_COMPONENT_QUARANTINE_COMPUTERS_AND_VIRTUAL_MACHINES_RESTORE_FORM } from '../../../webcomponents.constants';

export { QuarantineComputersAndVirtualMachinesRestoreForm };

window.customElements.define(
  WEB_COMPONENT_QUARANTINE_COMPUTERS_AND_VIRTUAL_MACHINES_RESTORE_FORM,
  QuarantineComputersAndVirtualMachinesRestoreForm
);
